import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ConsultaPreviaModel } from './../models/consulta-previa.model';
import { EndpointLocationProviderService } from './endpoint-location-provider.service';
import { environment } from '../../../environments/environment';
import { HttpErrorHandler, HandleError } from '../../http-error-handler.service';
import { Util } from '../utils/util';

@Injectable()
export class ConsultaPreviaService {

  private env = environment;
  private handleError: HandleError;
  private devURI = 'https://d-acsafeweb.safewebpss.com.br/Service/Microservice/Shared/ConsultaPrevia';

  private http: HttpClient = null;

  constructor(httpErrorHandler: HttpErrorHandler, private endpointLocationService: EndpointLocationProviderService, private handler: HttpBackend) {
    this.handleError = httpErrorHandler.createHandleError('ConsultaPreviaService');

    // cria o objeto manualmente para não ser interceptado pelo AuthInterceptor.
    this.http = new HttpClient(handler);
  }

  realizarConsultaPrevia(param: ConsultaPreviaModel): Observable<any> {
    const url = `${this.endpointLocationService.isLocalHost() ?
      this.devURI :
      (this.endpointLocationService.getWindowURL() + this.env.API_ENDPOINT_CONSULTAPREVIA.link)}/api/RealizarConsultaPrevia/`;

    return this.http
      .post(url, param, {
        headers: {
          'Authorization': Util.getTokenByHost()
        }
      })
      .pipe(
        catchError(this.handleError('Realizar Consulta Prévia', []))
      );
  }
}
